export default __webpack_public_path__ + "static/media/cloud-firestore.7dc6a703.png";